import { PartyListSections } from 'constants/service/singlePartyList';
import PartyListTabs from 'constants/service/partyListTabs';

export interface FunctionTypes {
  setPartyListTextFilter(filter: string): BaseTockAction;
  selectPartyListTab(tab: string): BaseTockAction;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setPartyListTextFilter(filter: any): BaseTockAction {
  return {
    type: 'SET_PARTY_LIST_TEXT_FILTER',
    payload: filter,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function selectPartyListTab(tab: PartyListTabs): BaseTockAction {
  return {
    type: 'SELECT_PARTY_LIST_TAB',
    payload: tab,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function selectGuestListSection(section: PartyListSections): BaseTockAction {
  return {
    type: 'SELECT_GUEST_LIST_SECTION',
    payload: section,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function selectGuestListTab(section: string): BaseTockAction {
  return {
    type: 'SELECT_GUEST_LIST_TAB',
    payload: section,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function toggleSortWalkInsByArrival(): BaseTockAction {
  return {
    type: 'TOGGLE_SORT_WALKINS_BY_ARRIVAL',
    context: {
      shouldTrack: true,
    },
  };
}
